import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ProductService } from '@services/product.service';
import { GlobalService } from '@services/global.service';
import { Product } from '@models/product';
import { Setting } from '@models/global';
import { RouteService } from '@services/route.service';
import { CartService } from '@services/cart.service'; // Service Panier indispensable
import { environment } from 'src/environments/environment';
import { GetPricesPipe } from 'src/app/core/pipe/price.pipe';
// import { env } from 'process';

@Component({
  selector: 'gob-home-selection',
  templateUrl: './home-selection.component.html',
  styleUrls: ['./home-selection.component.scss']
})
export class HomeSelectionComponent implements OnInit, AfterViewInit {

  // Référence aux conteneurs de scroll pour le centrage initial
  @ViewChildren('listeRef') listesElements: QueryList<ElementRef>;

  loading: boolean = false;
  isAlertOpen: boolean = false; 
  selectedProduct: any = null;

  products: { [key: string]: Product[] } = {};


  ind: number = 0;
  banners: any;

  imageErrors: { [key: string]: boolean } = {}; // Handle image load errors for each product by its ID

  // Category labels for display purposes
  categoryLabels: { [key: string]: { singular: string; plural: string, gender: string, type: string, url: string } } = {
    news: { singular: 'nouveauté', plural: 'nouveautés', gender: 'f', type: 'banner', url: 'nouveautes' },
    promos: { singular: 'promotion', plural: 'promotions', gender: 'f', type: 'banner', url: 'promotions' },
    used: { singular: 'occasion', plural: 'occasions', gender: 'f', type: 'gamme', url: 'jeux-d-occasion' },
    crush: { singular: 'coup de cœur', plural: 'coups de cœur', gender: 'm', type: 'banner', url: 'coups-de-coeur' },
    preorder: { singular: 'précommande', plural: 'précommandes', gender: 'f', type: 'banner', url: 'precommandes' },
    goldnGob: { singular: 'Gold n Gob', plural: 'Gold\'n\'Gob', gender: 'm', type: 'banner', url: 'gold-n-gob' }
  };

  constructor(
    private gServ: GlobalService,
    private pServ: ProductService,
    public route: RouteService,
    private cServ: CartService,
    private gPrice: GetPricesPipe,

  ) { }

/**
 * Returns true if the component has products, false otherwise.
 * @returns {boolean}
 */
  get hasProducts(): boolean {
    return this.products && Object.keys(this.products).length > 0;
  }

/**
 * Returns an array of product categories from the products object.
 * If the products object is empty, an empty array is returned.
 * @returns {string[]} An array of product categories.
 */

  readonly ORDRE_CATEGORIES_CLES = [
    'preorder',
    'news',
    'crush',
    'used',
    'promos',
    'goldnGob'
  ];
  get productCategories(): string[] {
      if (!this.products) return [];

      const keysPresentes = Object.keys(this.products);

      return this.ORDRE_CATEGORIES_CLES.filter(cle => keysPresentes.includes(cle));
    }

  ngOnInit(): void {
    this.loading = true;

    forkJoin({
      products: this.pServ.getSelected(),
      banners: this.gServ.getBanners()
    })
    .subscribe(values => {
      this.banners = values.banners;

      this.products = {};

      Object.entries(values.products).forEach(([category, list]) => {
        let productList = list as Product[];

        // On ne traite la catégorie que s'il reste des produits après filtrage
        if (productList.length > 0) {
          this.products[category] = this.prepareData(productList);
        }
      });

      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  /**
   * Helper pour le scroll infini :
   * 1. Si la liste est trop petite (<6), on la double jusqu'à remplir l'écran.
   * 2. On triple le résultat final pour permettre la boucle [A][A][A].
   */
  prepareData(list: Product[]): Product[] {
    if (!list || list.length === 0) return [];
    let baseList = [...list];

    // Gonfler la liste si < 6 éléments
    while (baseList.length < 6) {
      baseList = [...baseList, ...baseList];
    }

    // Tripler pour la mécanique de boucle
    return [...baseList, ...baseList, ...baseList];
  }

  // =========================================================
  // GESTION DU SCROLL INFINI (Events & Init)
  // =========================================================

  ngAfterViewInit() {
    // On attend un peu que le DOM soit rendu, puis on centre les listes
    setTimeout(() => {
      if (this.listesElements) {
        this.listesElements.forEach((elRef) => {
          const el = elRef.nativeElement;
          if (el.scrollWidth > el.clientWidth) {
             // On se place au début du 2ème tiers
             el.scrollLeft = el.scrollWidth / 3;
          }
        });
      }
    }, 500);
  }

  gererScrollInfini(event: any) {
    const el = event.target;
    const totalWidth = el.scrollWidth;
    const oneSetWidth = totalWidth / 3;

    // Si on arrive au tout début -> saut invisible vers le milieu
    if (el.scrollLeft < 50) {
       el.scrollLeft += oneSetWidth;
    }
    // Si on arrive à la toute fin -> saut invisible vers le milieu arrière
    else if (el.scrollLeft >= oneSetWidth * 2 - 50) {
       el.scrollLeft -= oneSetWidth;
    }
  }

  scrollListe(elementListe: any, direction: string) {
    const scrollAmount = 300;
    if (direction === 'droite') {
      elementListe.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else {
      elementListe.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  }

  getProductImage(prod: any): string {
    if (prod.mainImage && prod.mainImage.name) {
      return `${environment.imgUrl}/product/${prod.mainImage.name}`;
    } else if (prod.images && prod.images.length > 0) {
      return `${environment.imgUrl}/product/${prod.images[0].name}`;
    }
    return 'assets/img/no-image.png';
  }

  /**
   * Handle image load errors for each product by its ID.
   * Set imageErrors[productId] to true when an image load error occurs.
   * @param {string} productIdent - The ID of the product which has an image load error.
   */
    onImageError(productIdent: string): void {
    this.imageErrors[productIdent] = true;
  }

  // =========================================================
  // AJOUT AU PANIER (CORRIGÉ)
  // =========================================================
  addToCart(prod: any) {
    // Vérification de sécurité : le produit a-t-il un prix ?
    if (prod.prices && prod.prices.length > 0) {
      // APPEL CORRECT AU SERVICE : (Produit, Prix, Quantité)
      // On envoie le premier prix disponible et une quantité de 1
      this.cServ.add(prod, prod.prices[0], 1);

    } else {
      console.error('Impossible d\'ajouter au panier : prix introuvable pour', prod.name);
    }
  }

  /**
   * Return the ident of the menu item corresponding to the given category.
   * @param {string} categor - The category for which to retrieve the ident.
   * @returns {string} The ident of the menu item.
   */
  getTypeIdent(categ: any)
  {
    return environment.menuIdents[categ as keyof typeof environment.menuIdents];
  }

  /**
   * Return a string to display the "See all" button for a given category.
   * If the category has a corresponding name, it will be displayed in the string.
   * Otherwise, the string will be "Voir tout".
   * @param {string} categor - The category for which to retrieve the "See all" button string.
   * @returns {string} The string to display for the "See all" button.
   */
  getSeeAll(categ: any)
  {
    const label = this.categoryLabels[categ];
    if (label && label.gender === 'f') {
      return `Voir toutes les ${label.plural}`;
    } else {
      return `Voir tous les ${label?.plural || 'articles'}`;
    }
  }

  /**
   * Return the name of the category corresponding to the given ident.
   * If the category has a corresponding name, it will be returned in lowercase.
   * Otherwise, null will be returned.
   * @param {any} categor - The category for which to retrieve the name.
   * @returns {string|null} The name of the category, or null if no match is found.
   */
  getTypeName(categ: any)
  {
    const label = this.categoryLabels[categ];
    return label ? label.plural : null;
  }

  getFilterRoute(categ: any)
  {
    let filter: string[] = [];
    if (this.categoryLabels[categ]) {
      filter = [
        this.categoryLabels[categ].type,
        this.getTypeIdent(categ),
        this.categoryLabels[categ].url
      ];
    }
    return filter;
  }

  getThemeClass(category: string): string {
    const name = this.getTypeName(category)?.toLowerCase() || '';

    if (name.includes('coup')) return 'theme-rouge';
    if (name.includes('nouveaut')) return 'theme-vert';
    if (name.includes('précommande')) return 'theme-bleu';
    if (name.includes('promo')) return 'theme-orange';
    if (name.includes('gold')) return 'theme-jaune';
    if (name.includes('occasion')) return 'theme-noir';

    return 'theme-vert'; // Thème par défaut
  }

  openAlertModal(prod: any) {
    this.selectedProduct = prod;
    this.isAlertOpen = true;
  }

}
